@if (details.controls.length > 0) {
  <form [formGroup]="form" (submit)="handleSubmit()">
    <ng-container formArrayName="details">
      <div class="container">
        <div class="RepairCostDetailsRow__HeaderRow row">
          <div class="col-6">Item Description</div>
          <div class="col-4">Cost</div>
          <div class="col-2">&nbsp;</div>
        </div>
        @for (ctrl of details.controls; track ctrl; let i = $index) {
          <div class="row" [formGroupName]="i">
            <div class="col-6 p-2">
              <ion-item [id]="'name-' + i">
                <ion-input
                  formControlName="name"
                  placeholder="Name"
                  type="text"
                  #nameCtrl
                  required="true"
                  minlength="3"
                ></ion-input>
              </ion-item>
            </div>
            <div class="col-4 p-2">
              <ion-item [id]="'cost-' + i">
                <ion-input
                  formControlName="cost"
                  placeholder="Cost"
                  type="number"
                  (keydown.enter)="handleEnterKeyOnCost()"
                ></ion-input>
              </ion-item>
            </div>
            <div class="col-2 p-2">
              <ion-button
                class="RepairCostDetailsRow__Icon--delete"
                size="small"
                fill="solid"
                color="danger"
                shape="round"
                (click)="removeCost(i)"
                type="button"
              >
                <ion-icon name="trash" slot="icon-only"></ion-icon>
              </ion-button>
            </div>
          </div>
        }
      </div>
    </ng-container>
  </form>
} @else {
  <p class="warning">Please add a cost to using the Add cost button</p>
}
